jQuery(document).ready(function ($) {
  // Create tooltip once
  // Add once
  if (!$(".bsize60-tooltip").length) {
      $(".filter-item.bsize60").append(`
          <div class="bsize60-tooltip">
              Available With Downrod Motor Only
          </div>
      `);
  }
  if (!$(".hugger-tooltip").length) {
    $(".motor-type-selector .hugger").append(`
        <div class="hugger-tooltip">
            Hugger not available with 60" blades
        </div>
    `);
  }

// Hugger tooltip (only when disabled)
$(document)
.on("mouseenter", ".motor-type-selector .hugger.disabled", function () {

    const offset = $(this).offset();

    $("#custom-tooltip")
        .text('Hugger not available with 60" blades')
        .css({
            top: offset.top - 50,
            left: offset.left + ($(this).outerWidth() / 2)
        })
        .fadeIn(150);

})
.on("mouseleave", ".motor-type-selector .hugger.disabled", function () {

    $("#custom-tooltip").hide();

});

  if (!$(".blade-size-selector .blade-size-note").length) {
    $(".blade-size-selector p").after(
        '<div class="blade-size-note">Available With Downrod Motor Only</div>'
    );
  }
  //Blade Type Selection
  $(".blade-type-selector li").click(function () {
    var updateBladeType = $(this).attr("data-blade-type");
    var updateBladeText = $(this).attr("data-blade-text");

    $(".blade-type-selector  p .filter-blade-type ").text(updateBladeText);
    $(".filter-blade-type").attr("data-value", updateBladeType);
    $(".blade-type-selector .filter-item").removeClass("active");

    /* check if size 60 is selected, if selected, pre-select 46 */
    if (updateBladeType == "wing-tip" || updateBladeType == "leaf") {
      $(".blade-size-selector .filter-item.bsize60").hide();
      defaultBladeSize();
    }else{
      $(".blade-size-selector .filter-item.bsize60").show();
    }

    updateCurrentMainListing();
  });

  //Blade Count Selection
  $(".blade-count-selector li").click(function () {
    var updateBladeCount = $(this).attr("data-blade-count");
    var updateCountText = $(this).attr("data-count-text");
    $(".filter-blade-count").attr("data-value", updateBladeCount);
    $(".blade-count-selector .filter-item").removeClass("active");
    $(".blade-count-selector p .filter-blade-count").text(updateCountText);
    updateCurrentMainListing();
  });

  //Motor Type Selection
  $(".motor-type-selector li").click(function () {
    var updateMotorType = $(this).attr("data-motor-type");
    $(".filter-motor-type").attr("data-value", updateMotorType);
    $(".motor-type-selector .filter-item").removeClass("active");
    $(".motor-type-selector  p .filter-motor-type ").text(updateMotorType);

    if (
        $(this).hasClass("hugger") &&
        $(".filter-blade-size").attr("data-value") == "60"
    ) {
        return false;
    }
    /* check if size 60 is selected, if selected, pre-select 46 */
    if (updateMotorType == "hugger") {

      defaultBladeSize();
    }

    updateCurrentMainListing();
  });

  //Fan Type Selection
  $(".fan-type-selector li").click(function () {
    var currentMotor = $(".current-sub-listing .filter-motor-color").attr(
      "data-value",
    );
    var updateFanType = $(this).attr("data-fan-type");
    var updateFanImage = $(this).attr("data-fan-image");
    $(".filter-fan-type").attr("data-value", updateFanType);
    $(".fan-type-selector .filter-item").removeClass("active");
    $(".fan-type-selector  p .filter-fan-type ").text(updateFanType);
    $(".image-overlays .fan-img").attr("src", updateFanImage);
    updateCurrentMainListing();
  });

  //Light Type Selection
  $(".light-type-selector li").click(function () {
    var updateLightType = $(this).attr("data-light-type");
    if (updateLightType == "nrgb") {
      //remove this if-else code if ncct / cct is enabled
      $(".filter-light-type").attr("data-value", updateLightType);
      $(".light-type-selector .filter-item").removeClass("active");
      $(".light-type-selector p .filter-light-type ").text(
        updateLightType.replace("n", ""),
      );
      updateCurrentMainListing();
    }
  });

  //Blade Size Selection
  $(".blade-size-selector li").click(function () {

    var updateBladeSize = $(this).attr("data-blade-size");

    $(".filter-blade-size").attr("data-value", updateBladeSize);
    $(".filter-blade-size").text(updateBladeSize+'"');
    $(".blade-size-selector .filter-item").removeClass("active");
    $(this).addClass("active");

    if (updateBladeSize == "60") {

        $(".filter-motor-type").attr("data-value", "downrod");

        $(".motor-type-selector .filter-item").removeClass("active");
        $(".motor-type-selector .downrod").addClass("active");

        $(".motor-type-selector p .filter-motor-type")
            .text("Downrod");
    }

    updateCurrentMainListing();
  });

  //Motor Color Selection
  $(".motor-color-selector li").click(function () {
    var updateMotorColor = $(this).attr("data-motor-color");
    var updateMotorColorText = $(this)
      .attr("data-color-text")
      .replace(" motor", "");
    var updateMotorColorRestock = $(this).attr("data-restock");
    var updateStockNumber = $(this).attr("data-stockIndicator");

    //var updateMotorImage = $(this).attr("data-motor-image");
    $(".filter-motor-color").attr("data-value", updateMotorColor);
    $(".motor-color-selector p .filter-motor-color").text(updateMotorColorText);
    $(".motor-color-selector .filter-item").removeClass("active");

    //$('.image-overlays .motor-img').attr('src', updateMotorImage);
    if (updateMotorColorRestock != "") {
      $(".product-restocks").attr("data-restock-nval", updateMotorColorRestock);
    } else {
      $(".product-restocks").attr("data-restock-nval", "");
    }
    $("#currentSelection").attr("data-stockNum", updateStockNumber);
    updateStockIndicator();
    updateCurrentMainListing();
  });

  //Blade Color Selection
  $(".blade-color-selector li").click(function () {
    var updateBladeColor = $(this).attr("data-blade-color");
    var updateBladeColorText = $(this)
      .attr("data-color-text")
      .replace(" blade", "");
    //var updateBladeImage = $(this).attr("data-blade-image");
    $(".filter-blade-color").attr("data-value", updateBladeColor);
    $(".blade-color-selector p .filter-blade-color").text(updateBladeColorText);
    $(".blade-color-selector .filter-item").removeClass("active");
    //$('.image-overlays .blade-img').attr('src', updateBladeImage);
    updateCurrentMainListing();
  });

  updateCurrentMainListing();
  initialImages();
});
var wasCurveActive = false;
function updateCurrentMainListing() {
  //console.log("oasis pro updates");

  /* get current listing values */
  var currentBladeType = $(".current-main-listing .filter-blade-type").attr(
    "data-value",
  );
  var currentBladeCount = $(".current-main-listing .filter-blade-count").attr(
    "data-value",
  );
  var currentMotorType = $(".current-main-listing .filter-motor-type").attr(
    "data-value",
  );
  var currentFanType = $(".current-main-listing .filter-fan-type").attr(
    "data-value",
  );
  var currentLightType = $(".current-main-listing .filter-light-type").attr(
    "data-value",
  );
  var currentBladeSize = $(".current-sub-listing .filter-blade-size").attr(
    "data-value",
  );
  var currentBladeColor = $(".current-sub-listing .filter-blade-color").attr(
    "data-value",
  );
  var currentMotorColor = $(".current-sub-listing .filter-motor-color").attr(
    "data-value",
  );
  var productRestockMain = $(".current-sub-listing .filter-motor-color").attr(
    "data-restock",
  );
  var productRestockNumb = $(".current-sub-listing .filter-motor-color").attr(
    "data-stockIndicator",
  );

  $(".product-restocks .manual-delivery-disclaimer").remove();
  $(".product-restocks .timerBox").show();

  

  if (currentBladeSize == "60") {
      $(".blade-size-selector .blade-size-note").show();
  } else {
      $(".blade-size-selector .blade-size-note").hide();
  }
  /* always display 60" selector */
  if (currentBladeSize == "60") {

    $(".motor-type-selector .hugger")
        .addClass("disabled show-tooltip");

  } else {

      $(".motor-type-selector .hugger")
          .removeClass("disabled show-tooltip");

  }
  //show message for hugger
  if (currentMotorType == "downrod") {
    $(".motor-type-selector .hugger").addClass("show-tooltip");
  } else {
      $(".motor-type-selector .hugger").removeClass("show-tooltip");
  }

  /* manual set of hide/show sold out for oasis pro */
  //console.log(currentBladeType);
  //console.log(currentBladeSize);
  //console.log(currentBladeCount);
  
/* PLACE MANUAL SET OF PREORDER/OOS/RESTOCK HERE */


/* oasis pro */
// =====================================================
// OASIS PRO - DELIVERS FROM 25 JUNE 2026
// =====================================================

// Reset to default first
$("#currentSelection")
    .attr(
        "data-stocknum",
        $("#currentSelection").attr("data-defstocknum") || "1"
    )
    .attr(
        "data-restock",
        $("#currentSelection").attr("data-defrestock") || "Delivers 1-2 working days"
    );

let stock_available = false;
let deliverOct13 = false;


// Blade 46" Curved 3-Blades Dark Wood
if (
    currentBladeType == "curve" &&
    currentBladeSize == "46" &&
    currentBladeCount == "3-blades" &&
    currentBladeColor == "dark-wood-blade"
) {
    stock_available = true;
}

// Blade 46" Curved 5-Blades Dark Wood
if (
    currentBladeType == "curve" &&
    currentBladeSize == "46" &&
    currentBladeCount == "5-blades" &&
    currentBladeColor == "dark-wood-blade"
) {
    stock_available = true;
}

// Blade 46" Wing Tip 3-Blades Dark Wood
if (
    currentBladeType == "wing-tip" &&
    currentBladeSize == "46" &&
    currentBladeCount == "3-blades" &&
    currentBladeColor == "dark-wood-blade"
) {
    stock_available = true;
}
if (
    currentFanType == "standard" &&
    currentMotorType == "hugger" &&
    (currentBladeSize == "46" || currentBladeSize == "52") &&
    currentMotorColor == "light-wood-motor"
) {
    stock_available = true;
}



// Standard Hugger Dark Wood
if (
    currentMotorType == "hugger" &&
    (currentBladeSize == "46" || currentBladeSize == "52") &&
    currentMotorColor == "dark-wood-motor"
) {
    stock_available = true;
}

// Standard Downrod Matte White
if (
    currentFanType == "standard" &&
    currentMotorType == "downrod" &&
    (currentBladeSize == "46" || currentBladeSize == "52") &&
    currentMotorColor == "matte-white-motor"
) {
    stock_available = true;
}

// Standard Downrod Matte Black
if (
    currentFanType == "standard" &&
    currentMotorType == "downrod" &&
    (currentBladeSize == "46" || currentBladeSize == "52") &&
    currentMotorColor == "matte-black-motor"
) {
    stock_available = true;
}

if (stock_available) {

    $("#currentSelection")
        .attr("data-stocknum", "1")
        .attr("data-restock", "Delivers 1-2 working days");

}
if (deliverOct13) {

    $("#currentSelection")
        .attr("data-stocknum", "3")
        .attr("data-restock", "Deliver from 13 October onwards");

}
// =====================================================
// OASIS PRO - ARRIVES IN MID JULY
// =====================================================

let preorderLateNov = false;

if (
    currentFanType == "standard" &&
    currentMotorType == "downrod" &&
    (currentBladeSize == "46" || currentBladeSize == "52") &&
    currentMotorColor == "dark-wood-motor"
) {
    preorderLateNov = true;
}
if (
    currentBladeType == "curve" &&
    currentBladeSize == "52" &&
    currentBladeCount == "5-blades" &&
    currentBladeColor == "light-wood-blade"
) {
    preorderLateNov = true;
}

if (preorderLateNov) {

    $("#currentSelection")
        .attr("data-stocknum", "3")
        .attr("data-restock", "Delivers from late November onwards");

}




/* =============================
END OF MANUAL SET */

// =====================================================
// OASIS PRO MACARON OOS - STANDARD HUGGER ONLY
// =====================================================
if (
    window.location.pathname ===
    "/collections/smart-ceiling-fans/products/oasis-pro-macaron"
) {

    // Reset to default first
  $("#currentSelection")
      .attr(
          "data-stocknum",
          $("#currentSelection").attr("data-defstocknum") || "1"
      )
      .attr(
          "data-restock",
          $("#currentSelection").attr("data-defrestock") || "Delivers 1-2 working days"
      );

  let macaronLateOctober = false;

  // 52" Curved 3-Blades Cannoli Cream OOS

  if (
      currentBladeType == "curve" &&
      currentBladeSize == "52" &&
      currentBladeCount == "3-blades"
  ) {
    console.log('rewrote code');

      $(".filter-item.cannoli-cream-blade").addClass("disabled");

      if (currentBladeColor == "cannoli-cream-blade") {

          setTimeout(function () {
              $(".filter-item.sky-blue-blade:not(.disabled)").trigger("click");
          }, 100);

      }

  } else {

      $(".filter-item.cannoli-cream-blade").removeClass("disabled");

  }

    // Standard Hugger - Cannoli Cream
  // 46" / 52"
  // Arrives in Late October
  if (
      currentMotorColor == "cannoli-cream-motor" ||
      currentMotorColor == "champagne-pink-motor" ||
      currentMotorColor == "sky-blue-motor"
  ) {
      macaronLateOctober = true;
  }


  if (macaronLateOctober) {
      $("#currentSelection")
          .attr("data-stocknum", "3")
          .attr("data-restock", "Arrives Early November");

  }


}
/* end of macaron*/


  /* set the values as handles - to compare and be used for the classes */
  var currentMainHandle =
    currentBladeType +
    "-" +
    currentBladeCount +
    "-" +
    currentMotorType +
    "-" +
    currentFanType +
    "-" +
    currentLightType;
  var currentMainVariant =
    currentBladeSize + "-" + currentMotorColor + "-" + currentBladeColor;

  // add 'd' to curve. For display purposes. take note of this as it gets confusing have curve as the selector and curved as the display
  if (currentBladeType == "curve") {
    $(".blade-type-selector  p .filter-blade-type ").text(
      currentBladeType + "d",
    );
  }


  // display rgb + cct if rgb is selected
  if (currentLightType == "nrgb") {
    $(".light-type-selector  p .filter-light-type ").text("RGB + CCT");
  }
  /* set the boxes to active */
  $(".blade-type-selector .filter-item." + currentBladeType).addClass("active");
  $(".blade-count-selector .filter-item." + currentBladeCount).addClass(
    "active",
  );
  $(".motor-type-selector .filter-item." + currentMotorType).addClass("active");
  $(".fan-type-selector .filter-item." + currentFanType).addClass("active");
  $(".light-type-selector .filter-item." + currentLightType).addClass("active");
  $(".blade-size-selector .filter-item.bsize" + currentBladeSize).addClass(
    "active",
  );
  $(".blade-color-selector .filter-item." + currentBladeColor).addClass(
    "active",
  );
  $(".motor-color-selector .filter-item." + currentMotorColor).addClass(
    "active",
  );

  /* display the 60 size selection only for downrod curved */
  /* 60" is always available for selection */
  $(".filter-item.bsize60").addClass("enabled");


  /* set standard white or black image based on motor color */
  if (currentFanType == "standard") {
    if (
      currentMotorColor == "matte-black-motor" ||
      currentMotorColor == "dark-wood-motor"
    ) {
      var updateFanImage = $(".filter-item.standard.active").attr(
        "data-fan-image-black",
      );
    } else {
      var updateFanImage = $(".filter-item.standard.active").attr(
        "data-fan-image",
      );
    }
    $(".image-overlays .fan-img").attr("src", updateFanImage);
  }

  /* handle - url information */
  $(".current-main-listing-handle").text(currentMainHandle);
  $(".current-variant-listing-handle").text(currentMainVariant);

  var fullHandle = currentMainHandle + "-" + currentMainVariant;
  $(".current-full-handle").text(fullHandle);

  $(".indiv-prod").removeClass("active");
  $(".indiv-prod .variant-item").removeClass("active");
  $("#" + currentMainHandle).addClass("active");
  $("#" + fullHandle).addClass("active");

  /* ----------
    variant id - handling of information
  ----------- */
  var cartID = $("#" + fullHandle).attr("data-variant");
  var variantImage = $("#" + fullHandle).attr("data-image");
  //console.log(variantImage);
  var varPrice = $("#" + fullHandle).attr("data-price");
  var varCompare = $("#" + fullHandle).attr("data-compare");
  var varPercent = $("#" + fullHandle).attr("data-compare-percentage");
  var getGrab = $(".payment-alt-options .grab-info").attr("data-discount");

  var getAtome = $(".payment-alt-options .atome-info").attr("data-discount");

  var varVoucher = $("#" + fullHandle).attr("data-oasisVoucher");
  var updateVoucher = varPrice - varVoucher;

  if (varVoucher != "") {
    // if there is voucher, use voucher price to calculate grab/atome
    var initialAtome = updateVoucher / getAtome;
    var initialGrab = updateVoucher / getGrab;
  } else {
    var initialAtome = varPrice / getAtome;
    var initialGrab = varPrice / getGrab;
  }
  //console.log('variant ID:' +cartID);

  //update pricing, grab and atome from variant selected
  $("span#ProductPrice-product-template").text(
    "$" + varPrice.replace(".00", ""),
  );
  $("s#ComparePrice-product-template").text(
    "$" + varCompare.replace(".00", ""),
  );
  $("span#compare_precntage, .comparetooltip").text(varPercent);
  $(".payment-alt-options .grab-info.price-value, .voucher-pricing .grabpay-content .price span").text(Math.ceil(initialGrab));
  $(".payment-alt-options .atome-info.price-value").text(
    Math.ceil(initialAtome),
  );
  $(".voucher-pricing .voucher-wrap span#voucher-price").text(
    "$" + updateVoucher,
  );
  // update climate voucher price
  $(".voucher-pricing .tooltip .voucher-wrap .voucher-price").html(
    `$${Math.max(updateVoucher - window.cv_price, 0).toLocaleString()}`,
  );
  $(".product-form__cart span.voucher1").text("$" + updateVoucher);
  $("a#initateCheckout .voucher").text("$" + updateVoucher);

  //update variant image (smart or standard) displayed
  $(".image-overlays .blade-img").attr("src", variantImage);
  $(".image-overlays .blade-img").attr("data-src", variantImage);

  //add variant to cart link
  $("#currentSelection").attr("data-variant", cartID);
  $("#currentSelection").text(cartID);

  // update #currentSelection attributes
  $("#currentSelection").attr("data-price", varPrice);
  $("#currentSelection").attr("data-compare", varCompare);
  $("#currentSelection").attr("data-voucher", varVoucher);

  //update restock
  var currentToUpdateRestock = $(".product-restocks").attr("data-restock-nval");
  var varMainRestock = $("#" + fullHandle).attr("data-restock");
  //console.log("wata" + currentToUpdateRestock);
  if (currentToUpdateRestock != "") {
    //console.log('update1');
    $(".product-restocks").html(
      "<p class='text-center'>" + currentToUpdateRestock + "</p>",
    );
  } else {
    //console.log("wata2"+varMainRestock);
    if (varMainRestock == "") {
      $(".product-restocks").html(
        "<p class='text-center'>Delivers in 5-10 Working Days</p>",
      );
    } else {
      $(".product-restocks").html(
        "<p class='text-center'>" + varMainRestock + "</p>",
      );
      //console.log('blade-type'+currentBladeType);

      //console.log('regular');
      $(".product-restocks").html(
        "<p class='text-center'>" + varMainRestock + "</p>",
      );
      $(".stock-indicator").removeClass("active");
      $(".stock-indicator.text-success").addClass("active");
    }
  }
  updateStockIndicator();
  //console.log(cartID);
  if (cartID == undefined) {
    $("#AddToCart-button").addClass("disabled");
  } else {
    $("#AddToCart-button").removeClass("disabled");
  }
  $("#AddToCart-button").attr(
    "href",
    "/cart/add?id[]=" + cartID + "&quantity=1",
  );
}

function defaultBladeSize() {
  /* check if size 60 is selected, if selected, pre-select 46 */
  var getBladeSize = $(".current-sub-listing .filter-blade-size").attr(
    "data-value",
  );
  var defaultBladeSize = "46";
  if (getBladeSize == "60") {
    $(".filter-blade-size").attr("data-value", defaultBladeSize);
    $(".blade-size-selector .filter-item.bsize" + defaultBladeSize).addClass(
      "active",
    );
    $(".blade-size-selector .filter-item.bsize6").removeClass("active");
    $(".blade-size-selector p .filter-blade-size").text(defaultBladeSize + '"');
  }
}
function initialImages() {
  var currentFanType = $(".current-main-listing .filter-fan-type").attr(
    "data-value",
  );
  $(".fan-type-selector li." + currentFanType).click();

  var SmartOverlay = $("ul.filter.oasis-select .smart").attr("data-fan-image");
  var StandardOverlay = $("ul.filter.oasis-select .standard").attr(
    "data-fan-image",
  );
  $(".product-single__thumbnail .smart-fan").attr("src", SmartOverlay);
  $(".product-single__thumbnail .standard-fan").attr("src", StandardOverlay);
}
/*
function collectionSelection() {
  /* set initial variants when selected from the collection page 

  var urlString = document.referrer;
  var variantSelected = localStorage.getItem("prodType");
  console.log(urlString);
  if (urlString.indexOf("prismplus") > -1) {
    /* if inside prism 
    if (urlString.indexOf("variant") > -1) {
      /* if has variant, this means that there was a selection done between hugger or downrod 
      /* if there was a selection, the localStorage got updated 
      var motorString = variantSelected;
      var paramString =
        urlString.split("?")[0]; /* split the variant part to remove
      console.log(motorString);
    } else {
      /* if there is no selection, the localStorage is not updated so use the default 'hugger' as the selection 
      var motorString = "hugger";
      var paramString = urlString;
    }
    var bladeString = paramString.split("/products/")[1].replace("-blade", "");
    console.log('hello:'+variantSelected);
    if (bladeString == "curved") {
      /* since collection title uses curved, remove the d since 'curve' is the one used for selections 
      bladeString = "curve";
    } else if (bladeString == "wing-tip") {
      bladeString = "wing-tip";
    } else if ((bladeString = "leaf")) {
      bladeString = "leaf";
    } else {
      bladeString = "curve";
    }
    $(".blade-type-selector  p .filter-blade-type ").text(
      bladeString.replace("-", " ")
    );
    $(".filter-blade-type").attr("data-value", bladeString.toLowerCase());

    $(".filter-motor-type").attr(
      "data-value",
      motorString
    );
    $(".motor-type-selector  p .filter-motor-type ").text(motorString);
  } //outside prism, do nothing
}*/
jQuery(document).ready(function ($) {
  /* other functionalities here */

  /* change rgb text to rgb + cct */
  $(".filter-item.item.nrgb").text("RGB + CCT");

  /* size modal - added it here since orig popup modals are a little too crowded already */
  $(".v2-size-modal").click(function () {
    $(".oasisv2-size-modal").addClass("active");
    $(".stockclose").addClass("show bgshow");
  });
  $(".v2-smart-modal").click(function () {
    $(".oasisv2-smart-modal").addClass("active");
    $(".stockclose").addClass("show bgshow");
  });

  /* product slice rgb/cct - toggleswitch & content */
  $(".togglelight .switch li").click(function () {
    var clickedType = $(this).attr("data-type");
    //console.log(clickedType);
    $(".togglelight .s-item, .overlaybg").removeClass("active");
    $(".togglelight .s-item." + clickedType).addClass("active");
    $(".overlaybg." + clickedType + "-light").addClass("active");
    $($(this)).addClass("active");
  });

  $(".toggleremote .switch li").click(function () {
    var clickedType = $(this).attr("data-type");
    //console.log(clickedType);
    $(
      ".toggleremote .s-item, .toggleremote .image-wrap, .toggleremote .text-item",
    ).removeClass("active");
    $(".toggleremote .text-item." + clickedType).addClass("active");
    $(".toggleremote .image-wrap." + clickedType).addClass("active");
    $($(this)).addClass("active");
  });
});
/*
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}
*/

function setDisclaimers() {
  /* get list from disclaimer list div */
  /* get current selection */
  /* if current selection contains from the list, display disclaimer */
}
